import { render, staticRenderFns } from "./MEuropeanCartNew.vue?vue&type=template&id=2397ddac&scoped=true"
import script from "./MEuropeanCartNew.vue?vue&type=script&lang=js"
export * from "./MEuropeanCartNew.vue?vue&type=script&lang=js"
import style0 from "./MEuropeanCartNew.vue?vue&type=style&index=0&id=2397ddac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397ddac",
  null
  
)

export default component.exports